<template>
  <div class="head-box">
    <div class="logo"><img src="@/assets/images/logo.png" alt="" /></div>
    <div class="title-box">
      <h3>
        江苏工会
        <!-- <span class="loacalname"><i class="iconfont">&#xe603;</i>南京市</span> -->
      </h3>
      <p>12351网上法律服务站</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TopHead',
};
</script>
<style scoped>
.head-box {
  height: 160px;
  display: flex;
  align-items: center;
  padding: 0 7px;
  box-sizing: border-box;
}
.logo {
  width: 75px;
  height: 75px;
  overflow: hidden;
}
.logo img {
  width: 100%;
  height: 100%;
  display: block;
}
.title-box {
  margin-left: 10px;
}
.title-box h3 {
  line-height: 1;
  font-size: 35px;
  font-weight: bold;
  font-family: '微软雅黑';
  color: #fff;
  margin-bottom: 10px;
}
.title-box p {
  margin-bottom: 0;
  line-height: 1;
  font-size: 24px;
  color: #fff;
}
span.loacalname {
  font-size: 14px;
  font-weight: normal;
  margin-left: 10px;
}
span.loacalname i {
  margin-right: 6px;
}
</style>